import React from "react";
import Default from "./SubRequest";

const Search = () => {
    return (
        <Default />
    )
};

export default Search;